import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 group"
        >
          <div className="w-8 h-8 bg-primary-500/20 rounded-lg flex items-center justify-center group-hover:bg-primary-500/30 transition-colors">
            <i className="ri-hospital-line text-primary-500 text-lg"></i>
          </div>
          <span className="font-heading text-lg font-bold text-foreground-100 whitespace-nowrap">
            夜勤病栋
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/'
                ? 'text-primary-400 bg-primary-500/10'
                : 'text-foreground-400 hover:text-foreground-200 hover:bg-background-100'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === `/category/${cat.id}`
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-400 hover:text-foreground-200 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/about'
                ? 'text-primary-400 bg-primary-500/10'
                : 'text-foreground-400 hover:text-foreground-200 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-300 hover:text-foreground-100 hover:bg-background-100 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-3 py-2.5 rounded-md text-sm text-foreground-300 hover:text-foreground-100 hover:bg-background-100 transition-colors"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-300 hover:text-foreground-100 hover:bg-background-100 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2.5 rounded-md text-sm text-foreground-300 hover:text-foreground-100 hover:bg-background-100 transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}